document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', () => header?.classList.toggle('scrolled', window.scrollY > 50));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((e, i) => {
      if (e.isIntersecting) { setTimeout(() => e.target.classList.add('visible'), i * 100); observer.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

  const overlay = document.getElementById('cart-overlay');
  document.querySelectorAll('[data-cart-trigger]').forEach(btn => btn.addEventListener('click', () => overlay?.classList.add('open')));
  document.getElementById('cart-close')?.addEventListener('click', () => overlay?.classList.remove('open'));
  overlay?.addEventListener('click', e => { if (e.target === overlay) overlay.classList.remove('open'); });

  document.querySelectorAll('.product-card__actions').forEach(btn => {
    btn.addEventListener('click', async () => {
      const id = btn.dataset.variantId; if (!id) return;
      btn.textContent = 'Adding...';
      try {
        await fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({id, quantity:1}) });
        btn.textContent = 'Added ✓'; overlay?.classList.add('open');
        setTimeout(() => btn.textContent = 'Add to Selection', 2000);
      } catch { btn.textContent = 'Try Again'; }
    });
  });

  const heroBg = document.querySelector('.hero__bg');
  if (heroBg) window.addEventListener('scroll', () => { heroBg.style.transform = `scale(1.05) translateY(${window.scrollY * 0.2}px)`; }, { passive: true });
});
